import { Flex, Text } from "@radix-ui/themes";
import React, { Dispatch, SetStateAction } from "react";
import _, { compact, isUndefined } from "lodash";
import { t } from "i18next";
import { Button } from "../../ui/Button";
import { TbArrowsSort, TbSortAscending, TbSortDescending } from "react-icons/tb";

type Props = {
  sortingState: [boolean | undefined, Dispatch<SetStateAction<boolean | undefined>>];
  categoryName: string;
  changeSortingState: Function;
};

const SortingCategory = ({ sortingState, categoryName, changeSortingState }: Props) => {
  const [sorting, setSorting] = sortingState;

  const changeFilter = () => {
    if (isUndefined(sorting)) {
      setSorting(true);
      changeSortingState(true);
    } else {
      setSorting(!sorting);
      changeSortingState(!sorting);
    }
  };

  return (
    <div>
      <Text>{categoryName}</Text>
      <Button variant="default" size="small_icon" onClick={changeFilter}>
        {isUndefined(sorting) ? <TbArrowsSort /> : sorting ? <TbSortAscending /> : <TbSortDescending />}
      </Button>
      <Flex direction="column"></Flex>
    </div>
  );
};

export default SortingCategory;
